import React, { createContext, Dispatch, SetStateAction, useContext, useState } from 'react';
import { ChildrenProps } from '../../../../../types';

type DeviceListState = {
  updateMode: boolean;
  setUpdateMode: Dispatch<SetStateAction<boolean>>;
  selectedDeviceIds: string[];
  toggleDevice: (deviceId: string) => void;
  showUpdateAllDialog: boolean;
  setShowUpdateAllDialog: Dispatch<SetStateAction<boolean>>;
  clearSelectedDeviceIds: () => void;
};

const initialState: DeviceListState = {
  updateMode: false,
  setUpdateMode: () => null,
  selectedDeviceIds: [],
  toggleDevice: () => null,
  showUpdateAllDialog: false,
  setShowUpdateAllDialog: () => null,
  clearSelectedDeviceIds: () => null,
};

export const DeviceListContext = createContext(initialState);

export const useDeviceListContext = (): DeviceListState => useContext(DeviceListContext);

const DeviceListProvider: React.FC<ChildrenProps> = ({ children }) => {
  const [updateMode, setUpdateMode] = useState<boolean>(initialState.updateMode);
  const [selectedDeviceIds, setSelectedDeviceIds] = useState<string[]>(initialState.selectedDeviceIds);
  const [showUpdateAllDialog, setShowUpdateAllDialog] = useState<boolean>(false);

  const toggleDevice = (deviceId: string) => {
    setSelectedDeviceIds((prev) => {
      const tempList = [...prev];
      const index = tempList.findIndex((x) => x === deviceId);

      if (index !== -1) tempList.splice(index, 1);
      else tempList.push(deviceId);

      return tempList;
    });
  };

  const clearSelectedDeviceIds = () => setSelectedDeviceIds([]);

  const values: DeviceListState = {
    updateMode,
    setUpdateMode,
    selectedDeviceIds,
    toggleDevice,
    showUpdateAllDialog,
    setShowUpdateAllDialog,
    clearSelectedDeviceIds,
  };

  return <DeviceListContext.Provider value={values}>{children}</DeviceListContext.Provider>;
};

export default DeviceListProvider;
